import Money from '@/components/ui/Money';

export type GameBalanceView =
  | { kind: 'live'; amount: number }
  | { kind: 'last_known'; amount: number }
  | { kind: 'unknown' };

type BalanceFields = {
  inGameBalance?: number | null;
  balanceLive?: boolean;
  syncStatus?: string | null;
  lastSyncedAt?: string | null;
};

export function gameBalanceView(item: { balance?: BalanceFields | null }): GameBalanceView {
  const balance = item.balance;
  const raw = balance?.inGameBalance;
  const amount = raw == null ? null : Number(raw);
  const finite = amount != null && Number.isFinite(amount) ? amount : null;
  const live = balance?.balanceLive === true
    || (balance?.balanceLive == null && balance?.syncStatus === 'in_sync');
  if (live && finite != null) return { kind: 'live', amount: finite };
  if (!live && finite != null && balance?.lastSyncedAt) return { kind: 'last_known', amount: finite };
  return { kind: 'unknown' };
}

export function GameBalanceAmount({
  item,
  currency = 'USD',
  size = 'body',
  locale,
}: {
  item: { balance?: BalanceFields | null };
  currency?: string;
  size?: 'small' | 'body' | 'title';
  locale?: string;
}) {
  const view = gameBalanceView(item);
  if (view.kind === 'unknown') {
    return <span className="font-money text-body text-secondary" title="Balance unavailable">—</span>;
  }
  return (
    <span className="inline-flex min-w-0 items-baseline gap-1">
      <Money amount={view.amount} currency={currency} direction="out" size={size} locale={locale} />
      {view.kind === 'last_known' ? (
        <span className="font-ui text-caption text-secondary">Last known</span>
      ) : null}
    </span>
  );
}
